module.exports = __webpack_public_path__ + "media/images/icon_ul2-7a8c403312ae9aeca8bf1861179946e5.svg";